export class ReenvioEmailRequest {
   emisorId: string;
   usuarioId: string;
   dteId: string;
}
